import React, { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import the CSS
import "./Blogshow.css";
import { useNavigate } from "react-router-dom";

function Blogadd() {
  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  const url = process.env.REACT_APP_API_URL;
  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState("");
  const [isClient, setIsClient] = useState(false);
  const [categories, setCategories] = useState([]); // fetched categories
  const [selectedCategories, setSelectedCategories] = useState([]); // selected ones
  const categoryIds = selectedCategories.map((cat) => cat.value);
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${url}/api/category/fetch`);
        if (response.data.success) {
          const categoryOptions = response.data.categories
            .map((cat) => ({
              value: cat._id,
              label: cat.name,
            }))
            .sort((a, b) => a.label.localeCompare(b.label));
          setCategories(categoryOptions);
        } else {
          toast.error("Failed to fetch categories");
        }
      } catch (error) {
        toast.error("Failed to fetch categories", error);
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    setIsClient(true);
  }, []);
  // Handle Textarea Change (Edit Raw HTML)
  const [data, setData] = useState({
    title: "",
    url: "",
    introduction: "",
    content: "",
    metaDiscription: "",
    metaTitle: "",
    metaKeywords: "",
    categories: "",
    featuredImage: null,
    featuredImagePreview: null,
  });

  const handleFileUpload = async (e) => {
    e.preventDefault();

    if (!file) {
      toast.error("Please select a file first.");
      return;
    }

    const formData = new FormData();
    formData.append("upload", file); // "upload" should match the backend field name

    try {
      const response = await axios.post(
        `${url}/api/user/uploadFile`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.uploaded) {
        setFileUrl(response.data.url);
        toast.success("File uploaded successfully!");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Upload failed:", error);
      toast.error("Error uploading file.");
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(fileUrl);
    toast.success("Copied to clipboard!");
  };

  // new intigration
  useEffect(() => {
    // Ensure CKEditor is loaded
    if (!window.CKEDITOR) {
      console.error("CKEditor is not loaded.");
      return;
    }

    const introElement = document.getElementById("editor");
    const contentElement = document.getElementById("editor1");

    // Initialize CKEditor only if elements exist
    if (introElement) {
      const introEditor = window.CKEDITOR.replace("editor", {
        allowedContent: true,
        extraPlugins: "list,font",
        toolbar: [
          { name: "document", items: ["Source"] },
          { name: "basicstyles", items: ["Bold", "Italic", "Underline"] },
          { name: "paragraph", items: ["NumberedList", "BulletedList"] },
          { name: "insert", items: ["Image", "Table", "Link", "Unlink"] },
          { name: "styles", items: ["Format", "Font", "FontSize"] },
          { name: "colors", items: ["TextColor", "BGColor"] },
        ],
      });

      if (introEditor) {
        introEditor.on("instanceReady", function () {
          introEditor.setData(data.introduction || ""); // Avoid null values
        });

        introEditor.on("change", function () {
          setData((prev) => ({
            ...prev,
            introduction: introEditor.getData(),
          }));
        });
      } else {
        console.error("CKEditor failed to initialize for #editor.");
      }
    } else {
      console.error("Textarea with id='editor' not found.");
    }

    if (contentElement) {
      const contentEditor = window.CKEDITOR.replace("editor1", {
        extraPlugins: "list,font", // 🔹 Include "font" plugin
        toolbar: [
          { name: "document", items: ["Source"] },
          { name: "basicstyles", items: ["Bold", "Italic", "Underline"] },
          { name: "paragraph", items: ["NumberedList", "BulletedList"] },
          { name: "insert", items: ["Image", "Table", "Link", "Unlink"] },
          { name: "styles", items: ["Format", "Font", "FontSize"] }, // 🔹 Ensure "Font" and "FontSize" are present
          { name: "colors", items: ["TextColor", "BGColor"] },
        ],
      });

      if (contentEditor) {
        contentEditor.on("instanceReady", function () {
          contentEditor.setData(data.content || ""); // Avoid null values
        });

        contentEditor.on("change", function () {
          setData((prev) => ({
            ...prev,
            content: contentEditor.getData(),
          }));
        });
      } else {
        console.error("CKEditor failed to initialize for #editor1.");
      }
    } else {
      console.error("Textarea with id='editor1' not found.");
    }
  }, [isClient]);

  // wnd new integration
  const onChangehanndler = (event) => {
    const { name, value, files } = event.target;

    if (name === "title") {
      const slug = createSlug(value);
      setData((prev) => ({
        ...prev,
        title: value,
        url: slug, // Automatically update slug based on title
      }));
    } else if (name === "featuredImage") {
      const file = files?.[0];
      if (file) {
        setData((prev) => ({
          ...prev,
          featuredImage: file,
          featuredImagePreview: URL.createObjectURL(file),
        }));
      }
    } else {
      setData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const onsubmithandler = async (event) => {
    event.preventDefault();
    setData((prev) => ({
      ...prev,
      categories: categoryIds,
    }));
    // Validate the URL format
    if (createSlug(data.url) !== data.url) {
      toast.error("URL must contain only hyphens and small alphabets.");
      return; // Exit early if validation fails
    }

    try {
      // Make an API request
      const response = await axios.post(`${url}/api/user/addArticle`, data, {
        headers: { token },
      });

      // Handle the response
      if (response.data.success) {
        setData({
          title: "",
          url: "",
          introduction: "",
          content: "",
          metaDiscription: "",
          metaTitle: "",
          metaKeywords: "",
          categories: "",
          featuredImage: null,
          featuredImagePreview: null,
        });
        setSelectedCategories([]);
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      // Handle errors gracefully
      toast.error("An error occurred while submitting the article.");
      console.error(error);
    }
  };

  // Slug creation function
  function createSlug(title) {
    return title
      .toLowerCase() // Convert to lowercase
      .replace(/[^a-z0-9\s-]/g, "") // Remove all non-alphanumeric chars except spaces and hyphens
      .trim() // Trim leading/trailing spaces
      .replace(/\s+/g, "-") // Replace spaces with hyphens
      .replace(/-+/g, "-"); // Replace multiple hyphens with a single one
  }

  const handleFeatureUpload = async (file) => {
    if (!file) {
      toast.error("Please select a file first.");
      return;
    }

    const formData = new FormData();
    formData.append("upload", file); // "upload" should match the backend field name
    try {
      const response = await axios.post(
        `${url}/api/user/uploadFile`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.uploaded) {
        setData((prev) => ({
          ...prev,
          featuredImage: response.data.url, // Save URL from upload response
        }));

        toast.success("File uploaded successfully!");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Upload failed:", error);
      toast.error("Error uploading file.");
    }
  };

  return (
    <div className="container mt-5">
      <button
        className="btn btn-outline-primary my-2"
        onClick={() => navigate(`/blog-management/index`)}
      >
        <i className="fa fa-list mx-1"></i>
        List Blog
      </button>

      <ToastContainer />

      <form
        onSubmit={handleFileUpload}
        className="p-3 border rounded shadow-sm mb-3 w-50"
      >
        <label htmlFor="file" className="form-label fw-bold">
          <i className="fa fa-upload me-2"></i> Image Uploader
        </label>

        <input
          type="file"
          onChange={(e) => setFile(e.target.files[0])}
          className="form-control mb-2"
        />

        <p className="text-danger small">Max size: 2MB</p>
        <p className="text-danger small">
          Note: Copy the Url after Upload and use in the Article
        </p>

        <button type="submit" className="btn btn-success w-100">
          Upload
        </button>
        {/* Show File URL & Copy Button */}
        {fileUrl && (
          <div className="mt-3">
            <p>
              <strong>File URL:</strong>{" "}
              <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                {fileUrl}
              </a>
            </p>
            <button onClick={handleCopy} className="btn btn-primary">
              Copy URL
            </button>
          </div>
        )}
      </form>

      <form
        onSubmit={onsubmithandler}
        className="border p-4 rounded shadow-sm bg-light"
      >
        <h3 className="text-center mb-4">Add Article</h3>

        {/* Title */}
        <div className="form-group mb-3">
          <label className="required-field" htmlFor="title required-field">
            <i className="fa fa-heading me-2"></i>Title
          </label>
          <input
            type="text"
            name="title"
            required
            value={data.title}
            onChange={onChangehanndler}
            className="form-control"
            placeholder="Enter title"
            aria-required
          />
        </div>

        {/* URL */}
        <div className="form-group mb-3">
          <label className="required-field" htmlFor="url">
            <i className="fa fa-link me-2"></i>Slug
          </label>
          <input
            type="text"
            required
            name="url"
            value={data.url}
            onChange={onChangehanndler}
            className="form-control"
            placeholder="Enter Slug"
          />
        </div>

        {/* Featured Image */}
        <div className="form-group mb-3">
          <label className="required-field" htmlFor="featuredImage">
            <i className="fa fa-image me-2"></i>Featured Image
          </label>
          <input
            type="file"
            accept="image/*"
            name="featuredImage"
            onChange={(e) => {
              const file = e.target.files[0];
              if (file) {
                handleFeatureUpload(file);
              }
            }}
            className="form-control"
          />

          {data.featuredImage && (
            <img
              src={data.featuredImage}
              alt="Preview"
              className="img-fluid mt-2 rounded"
              style={{ maxHeight: "150px" }}
            />
          )}
        </div>

        {/* Introduction */}
        <div className="form-group mb-3">
          <label htmlFor="introduction">
            <i className="fa fa-info-circle me-2 "></i>
            <span className="required-field">Introduction</span>
            <p className="text-danger small">
              Note: Ensure the image is displayed with a strict width and height
              of 100%. <br /> Do not use H1 tag, use H2 onwards
            </p>
          </label>

          <textarea id="editor"></textarea>
        </div>

        <br />
        <br />

        {/* Content */}
        <div className="form-group mb-3">
          <label htmlFor="content">
            <i className="fa fa-align-left me-2"></i>Content
            <p className="text-danger small">
              Note: Ensure the image is displayed with a strict width and height
              of 100%. <br /> Do not use H1 tag, use H2 onwards
            </p>
          </label>
          <textarea id="editor1"></textarea>
        </div>

        <br />
        <br />

        <div className="form-group mb-3">
          <div className="row">
            {/* Meta Title Input */}
            <div className="col-md-6">
              <label htmlFor="metaTitle">
                <i className="fa fa-pen-nib me-2"></i>Meta Title
              </label>
              <input
                type="text"
                name="metaTitle"
                value={data.metaTitle}
                onChange={onChangehanndler}
                className="form-control"
                placeholder="Enter meta title"
              />
            </div>

            {/* Meta Keywords Input */}
            <div className="col-md-6">
              <label htmlFor="metaKeywords">
                <i className="fa fa-key me-2"></i>Meta Keywords
              </label>
              <input
                type="text"
                name="metaKeywords"
                value={data.metaKeywords}
                onChange={onChangehanndler}
                className="form-control"
                placeholder="Enter meta keywords"
              />
            </div>
          </div>
        </div>

        {/* Meta Description */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <label htmlFor="categories">
              <i className="fa fa-tags me-2"></i>Categories
            </label>
            <Select
              isMulti
              options={categories}
              value={selectedCategories}
              onChange={setSelectedCategories}
              placeholder="Select categories"
              className="basic-multi-select"
              classNamePrefix="select"
            />
          </div>
          <div className="col-md-6 mb-3">
            <label htmlFor="metaDescription">
              <i className="fa fa-file-alt me-2"></i>Meta Description
            </label>
            <textarea
              name="metaDiscription"
              onChange={onChangehanndler}
              value={data.metaDiscription}
              className="form-control"
              rows="4"
              placeholder="Enter meta description"
            />
          </div>
        </div>
        <br />

        {/* Submit Button */}
        <div className="text-center">
          <button type="submit" className="btn btn-primary px-5 py-2">
            <i className="fa fa-paper-plane me-2"></i>Submit
          </button>
        </div>
        <div className="d-flex justify-content-end">
          <button
            className="btn btn-outline-primary my-2"
            onClick={() => navigate(`/blog-management/index`)}
          >
            <i className="fa fa-list mx-1"></i>
            List Blog
          </button>
        </div>
      </form>
    </div>
  );
}

export default Blogadd;
